import WorkflowManagement from "../app/modules/adminrh/parametres/parametresJS/WorkflowManagement";
import SkillManagement from "../app/modules/skills/admin/SkillManagement";
import CampagneFormModal from "../app/modules/Formation/ResponsableFormation/RessourcesJs/campagnes/CampagneFormModal";
import CampagneCompetences from "../app/modules/skills/campagne/CampagneCompetences";
import CareerPathManagement from "../app/modules/skills/admin/CareerPathManagement";
import AutoEval from "../app/modules/skills/collab/AutoEval";
import EvalEquipe from "../app/modules/skills/manager/EvalEquipe";
import EvalRh from "../app/modules/skills/rf/EvalRh";
import RadarPage from "../app/modules/skills/viz/RadarPage";
import GapPage from "../app/modules/skills/viz/GapPage";
import ManagerGapPage from "../app/modules/skills/manager/ManagerGapPage";
import ManagerRadarPage from "../app/modules/skills/manager/ManagerRadarPage";
import RfGapPage from "../app/modules/skills/rf/RfGapPage";
import RfRadarPage from "../app/modules/skills/rf/RfRadarPage";
import {Route} from "react-router-dom";
import React from "react";
import SeuilPassageManagement from "../app/modules/jobs/SeuilPassage/SeuilPassageManagement";

export const SkillsRoutes = [
    { path: "admin/skills", element: <SkillManagement /> },
    { path: "/skills/responsable/campagnes", element: <CampagneCompetences /> },
    { path: "/skills/responsable/campagnes/add", element: <CampagneFormModal /> },
    { path: "/skills/responsable/campagnes/:id/edit", element: <CampagneFormModal /> },
    { path: "/skills/responsable/parcours", element: <CareerPathManagement /> },
    { path: "/skills/auto-evaluation", element: <AutoEval /> },
    { path: "/skills/eval-equipe", element: <EvalEquipe /> },
    { path: "/skills/eval-rh", element: <EvalRh /> },
    { path: "/skills/visualisation/radar", element: <RadarPage /> },
    { path: "/skills/visualisation/ecarts", element: <GapPage /> },
    { path: "/skills/manager/ecarts", element: <ManagerGapPage /> },
    { path: "/skills/manager/radar", element: <ManagerRadarPage /> },
    { path: "/skills/rf/ecarts", element: <RfGapPage /> },
    { path: "/skills/rf/radar", element: <RfRadarPage /> },
    { path: "/postes/seuils", element: <SeuilPassageManagement />},


];
